import { cn } from "@/utils/theme";
import { useWorkflowStore } from "@/workflow_api/store/workflowStore";
import { useUIStore } from "@/workflow_api/store/uiStore";
import { Button, Icon } from "@elaniintc/goes-design-system";
import { Handle, Position } from "@xyflow/react";

interface Props {
  id: string;
  isConnecting: boolean;
  isExecutionView?: boolean;
  onAdd: (event: React.MouseEvent, sourceId: string) => void;
  isSelected?: boolean;
  isDeleting?: boolean;
  hasError?: boolean;
  isValid?: boolean;
}

const Connection = ({
  id,
  isConnecting,
  isExecutionView,
  isDeleting,
  isSelected,
  hasError,
  isValid,
  onAdd,
}: Props) => {
  const { isHandleConnected } = useWorkflowStore();
  const { isFlowBlocked } = useUIStore();
  const isConnected = isHandleConnected(id);
  return (
    <div
      className="bg-transparent"
      style={{
        position: "absolute",
        top: "51%",
        right: -20,
        transform: "translateY(-50%)",
        width: "20px",
        height: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "8px",
      }}
    >
      {(!isExecutionView || isConnected) && (
        <Handle
          type="source"
          id="source"
          position={Position.Right}
          className="!rounded-none !border-none !bg-transparent z-40 !left-0 no-drag"
          style={{
            position: "relative",
            top: "50%",
            ...(isConnected
              ? {
                  transform: "translateY(-50%)",
                  width: "20px",
                  //pointerEvents: "none",
                }
              : {
                  transform: "translateY(-50%) translateX(200%)",
                }),
          }}
        >
          {!isConnected && isFlowBlocked ? null : (
            <>
              <div
                data-testid={`connection-source-indicator-${id}`}
                className={cn(
                  "w-[3px] h-3.5 bg-on-disabled rounded-r-full absolute pointer-events-none left-px",
                  isSelected && "bg-action-quiet",
                  (isDeleting || hasError) && "bg-danger-quiet",
                  isValid && "bg-success-quiet",
                )}
              />
              <div
                className={cn(
                  "h-px border border-neutral absolute top-1.5 -z-10 left-1 pointer-events-none ",
                  isConnected ? "w-[20px]" : "w-[20px]",
                  isSelected && "border-action-quiet",
                  hasError && "border-danger-quiet",
                  isValid && "border-success-quiet",
                )}
              />
            </>
          )}
        </Handle>
      )}

      {/* Add node button - only show if handle is not connected and flow is not blocked */}
      {!isConnected && !isExecutionView && !isFlowBlocked && (
        <div
          className={cn(
            "!bg-neutral-object relative size-8 flex items-center justify-center left-9",
            isConnecting && "opacity-0",
          )}
        >
          <Button
            variant="quiet"
            size="xs"
            aria-label="Add node"
            className="rounded-md border-[1.5px] size-8 no-drag"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onAdd(e, "source");
            }}
            style={{
              position: "relative",
              cursor: "pointer",
              transition: "all 0.2s ease",
              zIndex: 10,
            }}
          >
            <Icon type="far" name="plus" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default Connection;
